"use client";
import { useState } from "react";
import { AppTab } from "@/components/data";
import {
  CommandPalette,
  useCommandPalette,
} from "@/components/command-palette";
import type { ClinicAuthProof } from "@/components/clinic-auth-proof";
import IconSidebar from "@/components/layout/IconSidebar";
import TopBar from "@/components/layout/TopBar";
import TodayViewV5 from "@/components/views/TodayViewV5";
import { PatientDetailsDrawer } from "@/features/patient";

const CARD_COLLECTION_TAB = "tasks14" as AppTab;

export default function PSRApp({
  clinicAuthProof,
}: {
  clinicAuthProof?: ClinicAuthProof;
}) {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const cmdPalette = useCommandPalette();
  const [selectedPatientId, setSelectedPatientId] = useState<string | null>(
    null,
  );

  return (
    <div className="flex h-screen overflow-hidden bg-white">
      <CommandPalette
        isOpen={cmdPalette.isOpen}
        onClose={cmdPalette.close}
        onNavigateToTab={cmdPalette.close}
        onSelectPatient={(p) => setSelectedPatientId(p.patientId)}
      />

      <PatientDetailsDrawer
        patientId={selectedPatientId}
        onClose={() => setSelectedPatientId(null)}
      />

      <IconSidebar
        activeTab={CARD_COLLECTION_TAB}
        expanded={sidebarExpanded}
        onTabChange={() => undefined}
      />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <TopBar
          activeTab={CARD_COLLECTION_TAB}
          clinicAuthProof={clinicAuthProof}
          onOpenSearch={cmdPalette.open}
          sidebarExpanded={sidebarExpanded}
          onToggleSidebar={() => setSidebarExpanded((v) => !v)}
        />
        <TodayViewV5 />
      </div>
    </div>
  );
}
